var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, Pane, Tooltip } from "evergreen-ui";
import React from "react";
import { useHistory } from "react-router-dom";
export default function FeatureLabel(_a) {
    var type = _a.type, content = _a.content;
    var history = useHistory();
    return (_jsx(Pane, __assign({ margin: 5 }, { children: _jsx(Tooltip, __assign({ content: content }, { children: _jsx(Badge, __assign({ isInteractive: true, onClick: function () { return history.push("/upgrade"); }, color: "#49beef" }, { children: type })) })) })));
}
